export interface SiteSettings {
    show_showreel: boolean;
    show_featured_work: boolean;
    show_process: boolean;
    show_services: boolean;
    show_clients: boolean;
    show_project_detail: boolean;
    show_category_intro: boolean;
    show_enhanced_contact_fields: boolean;
    show_contact_cta: boolean;
}

export const defaultSiteSettings: SiteSettings = {
    show_showreel: true,
    show_featured_work: true,
    show_process: true,
    show_services: true,
    show_clients: true,
    show_project_detail: true,
    show_category_intro: true,
    show_enhanced_contact_fields: true,
    show_contact_cta: true,
};

export const siteSettingItems: Array<{
    key: keyof SiteSettings;
    title: string;
    description: string;
    priority: string;
}> = [
    {
        key: "show_showreel",
        title: "대표 쇼릴",
        description: "첫 화면 아래에 브랜드 톤을 압축해서 보여주는 쇼릴 영역",
        priority: "1순위",
    },
    {
        key: "show_featured_work",
        title: "대표 작업",
        description: "상위 작업 3개를 큐레이션해 전문성을 빠르게 전달",
        priority: "2순위",
    },
    {
        key: "show_process",
        title: "제작 프로세스",
        description: "상담부터 납품까지의 진행 방식을 명확하게 안내",
        priority: "3순위",
    },
    {
        key: "show_services",
        title: "서비스 범위",
        description: "제작 가능한 영상 유형과 담당 범위를 구조적으로 노출",
        priority: "4순위",
    },
    {
        key: "show_clients",
        title: "작업 분야/후기",
        description: "작업 가능한 산업군과 고객 관점 코멘트를 노출",
        priority: "5순위",
    },
    {
        key: "show_project_detail",
        title: "프로젝트 상세 보기",
        description: "Works 카드에서 케이스 스터디형 상세 페이지로 이동",
        priority: "6순위",
    },
    {
        key: "show_category_intro",
        title: "카테고리 소개",
        description: "Works 필터 아래에 카테고리별 전문 소개 문구 노출",
        priority: "7순위",
    },
    {
        key: "show_enhanced_contact_fields",
        title: "문의 상세 필드",
        description: "문의 폼에 영상 유형, 일정, 예산, 장소, 참고 URL 항목 노출",
        priority: "8순위",
    },
    {
        key: "show_contact_cta",
        title: "문의 유도",
        description: "예산, 일정, 참고 영상과 함께 문의하도록 전환 동선을 강화",
        priority: "9순위",
    },
];
